import React from 'react';
import '../styles/PurchaseDashboard.css';

const PurchaseDashboard = () => {
  // Dummy Data to keep JSX clean
  const kpiData = [
    { title: 'Total Purchases', value: '₹12,45,320', subtitle: 'This Month', icon: 'fas fa-shopping-cart', colorClass: 'blue' },
    { title: 'Total Bills', value: '128', subtitle: 'This Month', icon: 'fas fa-file-invoice', colorClass: 'green' },
    { title: 'Total Payable', value: '₹2,35,450', subtitle: 'Unpaid Amount', subtitleClass: 'text-red', icon: 'fas fa-rupee-sign', colorClass: 'orange' },
    { title: 'Total Paid', value: '₹10,09,870', subtitle: 'Paid Amount', subtitleClass: 'text-green', icon: 'fas fa-check-circle', colorClass: 'purple' },
    { title: 'Total Returns', value: '₹45,230', subtitle: 'This Month', icon: 'fas fa-undo', colorClass: 'red' }
  ];

  const tableData = [
    { id: 1, invoice: 'PUR-2025-128', supplier: 'Green Earth Nursery', supCode: 'SUP001', date: '20 May 2025', grn: 'GRN-2025-156', items: 15, amount: '₹25,450', paid: '₹25,450', due: '₹0', status: 'Paid' },
    { id: 2, invoice: 'PUR-2025-127', supplier: 'Premium Seeds Co.', supCode: 'SUP002', date: '19 May 2025', grn: 'GRN-2025-155', items: 8, amount: '₹18,760', paid: '₹10,000', due: '₹8,760', status: 'Partial' },
    { id: 3, invoice: 'PUR-2025-126', supplier: 'Grow More Fertilizers', supCode: 'SUP003', date: '18 May 2025', grn: 'GRN-2025-154', items: 12, amount: '₹32,150', paid: '₹0', due: '₹32,150', status: 'Unpaid' },
    { id: 4, invoice: 'PUR-2025-125', supplier: 'Plant Pots World', supCode: 'SUP004', date: '17 May 2025', grn: 'GRN-2025-153', items: 20, amount: '₹15,300', paid: '₹15,300', due: '₹0', status: 'Paid' },
    { id: 5, invoice: 'PUR-2025-124', supplier: 'Agro Care Solutions', supCode: 'SUP005', date: '16 May 2025', grn: 'GRN-2025-152', items: 7, amount: '₹22,890', paid: '₹5,000', due: '₹17,890', status: 'Partial' },
    { id: 6, invoice: 'PUR-2025-123', supplier: 'Shree Nursery Supplies', supCode: 'SUP006', date: '15 May 2025', grn: 'GRN-2025-151', items: 10, amount: '₹12,750', paid: '₹12,750', due: '₹0', status: 'Paid' },
    { id: 7, invoice: 'PUR-2025-122', supplier: 'Nature\'s Basket', supCode: 'SUP007', date: '14 May 2025', grn: 'GRN-2025-150', items: 9, amount: '₹8,650', paid: '₹0', due: '₹8,650', status: 'Unpaid' },
    { id: 8, invoice: 'PUR-2025-121', supplier: 'Bhoomi Soil Supplier', supCode: 'SUP008', date: '13 May 2025', grn: 'GRN-2025-149', items: 18, amount: '₹27,360', paid: '₹27,360', due: '₹0', status: 'Paid' }
  ];

  return (
    <div className="dashboard-wrapper">
      {/* KPI Cards */}
      <div className="kpi-grid">
        {kpiData.map((kpi, index) => (
          <div className="kpi-card" key={index}>
            <div className={`kpi-icon ${kpi.colorClass}`}>
              <i className={kpi.icon}></i>
            </div>
            <div className="kpi-details">
              <p className="kpi-title">{kpi.title}</p>
              <h3 className="kpi-value">{kpi.value}</h3>
              <p className={`kpi-subtitle ${kpi.subtitleClass || ''}`}>{kpi.subtitle}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Main Content Box */}
      <div className="main-content-box">
        {/* Tabs */}
        <div className="tabs-container">
          <button className="tab active"><i className="fas fa-award"></i> Purchase Entry</button>
          <button className="tab"><i className="fas fa-list"></i> All Purchases</button>
          <button className="tab"><i className="fas fa-lock"></i> Purchase Orders <span className="badge">18</span></button>
          <button className="tab"><i className="fas fa-file-alt"></i> GRN <span className="badge">24</span></button>
          <button className="tab"><i className="fas fa-undo"></i> Purchase Returns <span className="badge">7</span></button>
        </div>

        {/* Action Bar */}
        <div className="action-bar">
          <div className="filter-group">
            <div className="input-icon-wrapper">
              <input type="text" defaultValue="01/05/2025 - 20/05/2025" />
              <i className="far fa-calendar-alt"></i>
            </div>
            <select><option>All Suppliers</option></select>
            <select><option>All Status</option></select>
            <div className="input-icon-wrapper search-bar">
              <input type="text" placeholder="Search by invoice no, challan no..." />
              <i className="fas fa-search"></i>
            </div>
          </div>
          <div className="action-buttons">
            <button className="btn btn-outline"><i className="fas fa-filter"></i> Filters</button>
            <button className="btn btn-primary"><i className="fas fa-plus"></i> New Purchase</button>
          </div>
        </div>

        {/* Table */}
        <div className="table-responsive">
          <table className="data-table">
            <thead>
              <tr>
                <th><input type="checkbox" /></th>
                <th>#</th>
                <th>Invoice No</th>
                <th>Supplier</th>
                <th>Invoice Date</th>
                <th>GRN No</th>
                <th>Total Items</th>
                <th>Amount</th>
                <th>Paid</th>
                <th>Due</th>
                <th>Status</th>
                <th className="text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              {tableData.map((row) => (
                <tr key={row.id}>
                  <td><input type="checkbox" /></td>
                  <td className="text-muted">{row.id}</td>
                  <td className="text-blue fw-500 cursor-pointer">{row.invoice}</td>
                  <td>
                    <div className="fw-500 text-dark">{row.supplier}</div>
                    <div className="text-small text-muted">{row.supCode}</div>
                  </td>
                  <td className="text-muted-dark">{row.date}</td>
                  <td className="text-blue fw-500 cursor-pointer">{row.grn}</td>
                  <td className="text-muted-dark">{row.items}</td>
                  <td className="fw-500 text-dark">{row.amount}</td>
                  <td className={row.paid !== '₹0' ? 'text-green' : 'text-muted-dark'}>{row.paid}</td>
                  <td className={row.due !== '₹0' ? 'text-red fw-500' : 'text-dark'}>{row.due}</td>
                  <td>
                    <span className={`status-badge ${row.status.toLowerCase()}`}>{row.status}</span>
                  </td>
                  <td className="text-center action-cells">
                    <button className="action-icon"><i className="fas fa-eye"></i></button>
                    <button className="action-icon"><i className="fas fa-print"></i></button>
                    <button className="action-icon"><i className="fas fa-ellipsis-v"></i></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="pagination-bar">
          <div className="pagination-info">Showing 1 to 8 of 128 entries</div>
          <div className="pagination-controls">
            <button className="page-btn"><i className="fas fa-chevron-left"></i></button>
            <button className="page-btn active">1</button>
            <button className="page-btn">2</button>
            <button className="page-btn">3</button>
            <button className="page-btn">4</button>
            <button className="page-btn">5</button>
            <span className="page-dots">...</span>
            <button className="page-btn">16</button>
            <button className="page-btn"><i className="fas fa-chevron-right"></i></button>
          </div>
          <div className="pagination-size">
            <span>Show</span>
            <select><option>10</option></select>
            <span>per page</span>
          </div>
        </div>
      </div>

      {/* Footer Summary */}
      <div className="footer-summary">
        <div className="footer-item">
          <div className="kpi-icon blue"><i className="fas fa-shopping-bag"></i></div>
          <div>
            <p className="footer-label">Total Purchase (This Month)</p>
            <h4 className="footer-value">₹12,45,320</h4>
          </div>
        </div>
        <div className="footer-item">
          <div className="kpi-icon green"><i className="fas fa-file-invoice-dollar"></i></div>
          <div>
            <p className="footer-label">Total Paid</p>
            <h4 className="footer-value">₹10,09,870</h4>
          </div>
        </div>
        <div className="footer-item">
          <div className="kpi-icon red"><i className="fas fa-lock"></i></div>
          <div>
            <p className="footer-label">Total Payable / Due</p>
            <h4 className="footer-value text-red">₹2,35,450</h4>
          </div>
        </div>
        <div className="footer-item">
          <div className="kpi-icon blue"><i className="fas fa-file-alt"></i></div>
          <div>
            <p className="footer-label">Total Bills</p>
            <h4 className="footer-value">128</h4>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PurchaseDashboard;